// extracted by mini-css-extract-plugin
export default {"root":"Input_root__O-YU0","input":"Input_input__k5Ctk","error":"Input_error__1wKFK","label":"Input_label__U9NhE","errorDescription":"Input_errorDescription__u8AWs"};